/**
 *
 * ModalBox
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';

import media from '../../style/mediainjector';
import { FlexBox, Div } from '../Blocks';
import { Button } from '../Button';

const fadeIn = keyframes`
  0% {
    opacity: 0:
  } 100% {
    opacity: 100;
  }
`;

export const ModalOverlay = styled(FlexBox)`
  background-color: ${(props) => (props.overlaybg ? props.overlaybg : props.theme.modalbg)};
  position: fixed;
  top: 0;
  left: 0;
  right:0;
  bottom: 0;
  z-index: 16;
  overflow: auto;
  opacity: 0;
  animation: ${fadeIn} .3s ease-in forwards;
`;

export const ModalContent = styled(Div)`
  position: relative;
  max-width: ${({ maxWidth }) => (maxWidth || '860px')};
  background-color: ${({ bgcolor }) => (bgcolor || 'rgb(255,255,255)')};
  box-shadow: 0px 2px 11px -2px rgba(0,0,0,0.5);
  border-radius: 6px;
  padding: 0 20px;
  ${media.mobile`
    margin: 10px;
  `}
  ${media.lt667`
    width: 100%;
    overflow-y: auto;
  `}
  ${(props) => props.formBox && css`
    max-width: 480px;
    background-color: ${props.bgcolor ? props.bgcolor : props.theme.brand};
    color: ${props.color ? props.color : '#fff'};
    a {
      color: #fff;
      padding: 0 2px;
      text-decoration: underline;
      border-radius: 2px;
      &:hover {
        color: ${props.theme.brand};
        background-color: rgba(255, 255, 255, 1);
        text-decoration: none;
      }
    }
    h2 {
      color: currentColor;
      text-align: center;
      margin-top: 0;
    }
    p {
      margin-bottom: 6px;
    }
    ${media.lt667`
      width: 100%;
    `}
    ${media.lt480`
      height: 100%;
      margin: 0;
      overflow-y: auto;
      border-radius: 0;
      min-width: auto;
    `}
  `}
`;

export const ModalHeader = styled.h3`
  color: ${(props) => props.theme.brand};
  margin: 0;
  padding: 20px;
`;

export const ModalFooter = styled(FlexBox)`
  padding: 20px;
  button {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 46px;
    border-radius: 0 0 6px 6px;
  }
`;

class ModalBox extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  closeFunction = ({ beforeCloseFunction }) => {
    const { closeFunction } = this.props;

    if (beforeCloseFunction) {
      const response = beforeCloseFunction();

      if (response) {
        closeFunction();
      }
    } else {
      closeFunction();
    }
  };

  render() {
    const {
      messages = [],
      maxWidth,
      color,
      bgcolor,
      overlaybg,
      closeFunction,
    } = this.props;

    if (!messages.length) {
      return null;
    }

    const {
      titolo,
      contenuto,
      formBox,
      closeButton: {
        beforeCloseFunction,
        hide: buttonHide = false,
        text: buttonText = 'Chiudi',
      } = {},
    } = messages[0];

    const closeFx = () => this.closeFunction({ beforeCloseFunction });

    return (
      <ModalOverlay overlaybg={overlaybg}>
        <ModalContent bgcolor={bgcolor} formBox={formBox} color={color} maxWidth={maxWidth}>
          {titolo && <ModalHeader>{titolo}</ModalHeader>}
          {typeof contenuto !== 'function' && contenuto}
          {typeof contenuto === 'function' && contenuto({
            formInviatoCallbackFunction: closeFx,
            annullaFunction: closeFunction,
          })}
          {!buttonHide && (
            <ModalFooter>
              <Button
                onClick={closeFx}
              >
                {buttonText}
              </Button>
            </ModalFooter>
          )}
        </ModalContent>
      </ModalOverlay>
    );
  }
}

ModalBox.propTypes = {
  closeFunction: PropTypes.func.isRequired,
  color: PropTypes.string,
  bgcolor: PropTypes.string,
  maxWidth: PropTypes.string,
  overlaybg: PropTypes.string,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      formBox: PropTypes.bool,
      titolo: PropTypes.string,
      contenuto: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func,
      ]).isRequired,
      closeButton: PropTypes.shape({
        hide: PropTypes.bool,
        text: PropTypes.string,
        beforeCloseFunction: PropTypes.func,
      }),
    }),
  ).isRequired,
};

export default ModalBox;
